import { ajax } from 'cadenza/api-client/api';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { lazy } from 'cadenza/utils/promise-utils';

export interface HelpTopicLinkCallback {
  (topicId: string): Promise<string>;
}

const getAvailableHelpPagesTopicIdsLazy = lazy(() => ajax<string[]>('/help-topics'));

export function getHelpTopicUrlForId (topicId: string): Promise<string> {
  return getAvailableHelpPagesTopicIdsLazy()
    .then((availableTopicIds: string[]) => {
      // cch- prefix according to HelpTopicsUtilities.HELP_TOPIC_FILE_PREFIX
      return availableTopicIds.includes('cch-' + topicId);
    })
    .then((isTopicIdValid: boolean) => {
      if (isTopicIdValid) {
        return cadenzaUrl('/help-topics/cch-' + topicId + '.html');
      } else {
        throw new Error('The help referenced by the topicId [' + topicId + '] was not found.');
      }
    });
}
